import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import { getConfig } from '@townsquare/config';
import { PRODUCT_DISPLAY_NAME } from '@townsquare/config/constants';

import { fetchGraphQLFromUrl, logMissingRequiredField } from './RelayEnvironment';

const EXPERIMENTAL_JIRA_API_HEADER = { 'X-ExperimentalApi': 'JiraIssueSearch' };

// These types are prefixed with the AGG prefix to avoid conflicts with other types
const AGG_PREFIX_TYPES = ['SearchResultAtlasGoal', 'SearchResultAtlasProject'];

const config = getConfig();
export const AggRelayEnvironment = new Environment({
  configName: `${PRODUCT_DISPLAY_NAME} AGG GraphQL`,
  network: Network.create(fetchGraphQLFromUrl({ defaultUrl: config.aggGraphQLUrl })),
  store: new Store(new RecordSource()),
  relayFieldLogger: logMissingRequiredField,
  getDataID: (fieldValue, typeName) => {
    if (AGG_PREFIX_TYPES.includes(typeName)) {
      return `${typeName}:${fieldValue.id}`;
    }

    return fieldValue.id;
  },
});

export const AggExperimentalJiraRelayEnvironment = new Environment({
  configName: `${PRODUCT_DISPLAY_NAME} AGG GraphQL Experimental`,
  network: Network.create(
    fetchGraphQLFromUrl({
      defaultUrl: config.aggGraphQLUrl,
      multiRegionUrl: undefined,
      customHeaders: EXPERIMENTAL_JIRA_API_HEADER,
    }),
  ),
  store: new Store(new RecordSource()),
  relayFieldLogger: logMissingRequiredField,
});
